const generatePromotionType = (promotionType: string, isPdf?: boolean) => {
  const regex = /v2$/
  const isBmsm = promotionType?.toLowerCase()?.includes('bmsm')
  if (isBmsm) {
    const oldBmsm = isPdf ? promotionType : `${promotionType} (old)`
    return regex.test(promotionType) ? promotionType.slice(0, -3) : oldBmsm
  }

  return promotionType
}

export default generatePromotionType
